import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrJsaAddPage } from './klmr-jsa-add';

@NgModule({
  declarations: [
    KlmrJsaAddPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrJsaAddPage),
  ],
})
export class KlmrJsaAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-jsa-add/klmr-jsa-add.module.ts